<template>
    <div
      class="modal fade"
      id="subirfactura"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Subir Factura Digital</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12">
            <input
            type="file"
            class="form-control"
            id="file"
            ref="file"
            v-on:change="handleFileUpload()"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="SubirImagenScan()"
            >
              Guardar Imagen
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  components: {},
  data() {
    return {
      file: null,
    };
  },
  props: ["current"],
  computed: {},
  mounted() {},
  methods: {
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    SubirImagenScan() {
      let self = this;
      self.current.fecha_revision = "";
      console.log(this.file)
      if (this.file == null) {
        Notifications.alert.error(
          "Guardar imagen de factura",
          "No hay ninguna archivo adjunto, por favor seleccione una imagen antes.",
        );
      }
      DynamicService.updateFileWithPost(
        "wms",
        "facturas",
        this.current,
        this.file
      )
        .then((res) => {
          self.file = "";
          $("#subirfactura").modal("hide");
          Notifications.alert.success(
            "Subir Factura Digital",
            "Realizado correctamente"
          );
        })
        .catch((error) => {
          self.file = null;
          Notifications.alert.error(
            "Subir Factura Digital",
            "No se pudo enviar el archivo"
          );
        });
    },
  },
};
</script>
